import { ValidationSchema } from "./validation-schema";
const isNil = (value: any): boolean =>
  typeof value === "undefined" || value === null;

// validates an input using a formData object, schema, and input name
// Example:
//   isInputValid({
//     formData: {applicant_email: "foo@bar.com", "first_name: "Jane"},
//     name: "applicant_email",
//     label: "Email" (optional)
//     validationSchema: [{name: "applicant_email", required: true, type: "string"}]
//   })
//   >>> [true, ""]   // or if false: [false, "Email is required"]
// isInputValid({formData: Object, name: String, validationSchema: [Object]}) :: [Bool, String]
//
export const isInputValid = <T extends { [key: string]: any }>(data: {
  formData: T;
  name: string;
  label?: string;
  validationSchema: ValidationSchema[];
}): [boolean, string] => {
  const { formData, name, label, validationSchema } = data;
  const value = formData[name];
  const validation = validationSchema.find(item => item.name === name);
  if (typeof validation === "undefined") return [true, ""];

  const isEmptyValue = isNil(value) || value === "";
  if (validation.required && isEmptyValue) {
    return [false, `${label || name} is required`];
  }

  if (validation.type && !isNil(value) && validation.type !== typeof value) {
    return [false, `${name} is not the correct type (${typeof value})`];
  }

  return [true, ""];
};
